import { FC } from 'react';
import React from 'react';
import isEqual from 'react-fast-compare';

import { useSegmentAudioContext } from './SegmentAudioContextStore';
import { Utterance } from './types';

interface UtteranceTimestampProps {
  utterance: Utterance;
  nextUtteranceStartAt: number | null;
  children: React.ReactNode;
}

const UtteranceTimestamp: FC<UtteranceTimestampProps> = (props) => {
  const { utterance, nextUtteranceStartAt, children } = props;
  const { audioPlayerHandle, store } = useSegmentAudioContext();
  const goToTimestampInAudio = () => {
    if (utterance.startAt && utterance.endAt) {
      audioPlayerHandle?.current?.seekTo(utterance.startAt);
      if (audioPlayerHandle?.current?.isPaused()) {
        audioPlayerHandle?.current?.play();
      }
      // Sets the repeat section in the audio player
      audioPlayerHandle.current?.setSectionStartEnd(
        utterance.startAt,
        nextUtteranceStartAt
          ? Math.max(nextUtteranceStartAt - 0.3, utterance.endAt)
          : utterance.endAt,
      );
      // Set the active utterance ID in the store
      store.send({
        type: 'updateActiveUtteranceId',
        utteranceId: utterance.id,
      });
    }
  };
  return (
    <p
      className="col-start-3 flex cursor-pointer items-center justify-center pr-1 text-right font-mono text-sm font-medium text-text-tertiary hover:underline data-karaoke-active:bg-bg-orange-strong"
      data-karaoke-utterance-id={utterance.id}
      onClick={goToTimestampInAudio}
    >
      {children}
    </p>
  );
};

export const MemoizedUtteranceTimestamp = React.memo(
  UtteranceTimestamp,
  isEqual,
);
